// removed by extract-text-webpack-plugin
module.exports = {"Article":"_1NXs5","ArticleInner":"_3G6iW","ArticleSlideZero":"_3wH3h","ArticleSlideOne":"_13eQO","ArticleSlideTwo":"_3DsVp","ArticleTablet":"_1nMhR"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Article/Article.scss
// module id = 451
// module chunks = 0